import { EventBus } from "../../../eventbus";
import uniqid from "uniqid";

export default {
  data() {
    return {
      id: this.$options.name,
      snackbarItems: [],
    };
  },
  created() {
    EventBus.$on(`${this.id}--add`, (data) => {
      this.add(data);
    });

    EventBus.$on(`${this.id}--remove`, (id) => {
      this.remove(id);
    });
  },
  methods: {
    add(data) {
      this.snackbarItems.push({
        id: uniqid(),
        ...data,
      });
    },

    remove(id) {
      this.snackbarItems = this.snackbarItems.filter((item) => item.id !== id);
    },
  },
};
